import { render, staticRenderFns } from "./salesByRingStatus.vue?vue&type=template&id=afeaea98"
import script from "./salesByRingStatus.vue?vue&type=script&lang=js"
export * from "./salesByRingStatus.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports